import { useQuery } from '@tanstack/react-query'

import { api } from './client'
import type { Me } from './types'

/**
 * Who is signed in.
 *
 * `/auth/me` answers 200 with `signed_in: false` rather than 401, so being
 * signed out is a normal answer here and not an error state the UI has to
 * special-case. Cached for the session: it changes on sign-in and sign-out,
 * both of which are full navigations.
 */
export function useMe() {
  return useQuery({
    queryKey: ['me'],
    queryFn: () => api.get<Me>('/auth/me'),
    staleTime: 5 * 60 * 1000,
    retry: false,
  })
}
